















import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import CategoryChooserService from '~/services/category/CategoryChooserService'
import CategoryChooserSection from '~/components/car/category/chooser/CategoryChooserSection.vue'
import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CBreadcrumbs,
    CategoryChooserSection
  },
  async asyncData({ route, $dep, $logger, app: { i18n } }) {
    const categoryChooserService = $dep(CategoryChooserService)
    try {
      const {
        sections: fetchedSections,
        breadcrumbs
      } = await categoryChooserService.getClassifiedCreateIndexCategories()

      let sections = fetchedSections
      if (route.params.vtype) {
        const foundSection = fetchedSections.find(
          s => s.type === route.params.vtype
        )
        if (foundSection) {
          foundSection.label = i18n.t(`new_${route.params.vtype}`)
          sections = [foundSection]
        }
      }
      return {
        sections,
        breadcrumbs
      }
    } catch (error) {
      $logger.captureError(error)
    }
  },
  data() {
    return {
      sections: [],
      breadcrumbs: null,
      anonGuardModalVisible: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, ['isAnon'])
  }
})
